import { TournamentStatus } from '@/models/tournament/status';
import { Nullable } from '@starsoft/common/interfaces';
import { Tab } from '@starsoft/common/src/components/Tabs/Tab/props';

export const tournamentsTabs: Tab<Nullable<TournamentStatus>>[] = [
  {
    label: 'lobby_label',
    value: null,
    icon: 'fa-duotone fa-house',
  },
  {
    label: 'upcomming_label',
    value: TournamentStatus.Open,
    icon: 'fa-duotone fa-calendar',
  },
  {
    label: 'closed_label',
    value: TournamentStatus.Closed,
    icon: 'fa-duotone fa-close',
  },
];
